export const navigationSelector = state => state.navigation;
